// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs_2uzld","link":"Breadcrumbs_link_2dO-e"};